import { Button, CircularProgress, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';

type LocationReviewActionsProps = {
  isSubmitting: boolean;
  isRejecting: boolean;
  markerMoveBlocking: boolean;
  hasStagedChange: boolean;
  onReject: () => void;
};

export const LocationReviewActions = ({
  isSubmitting,
  isRejecting,
  markerMoveBlocking,
  hasStagedChange,
  onReject,
}: LocationReviewActionsProps): JSX.Element => {
  const { t } = useTranslation();
  const isSubmittingOrRejecting = isSubmitting || isRejecting;

  return (
    <Stack direction="row" spacing={2}>
      <Button
        type="submit"
        fullWidth
        size="large"
        color="success"
        variant="contained"
        disabled={
          isSubmittingOrRejecting || markerMoveBlocking || hasStagedChange
        }
      >
        {isSubmitting ? (
          <CircularProgress size={24} />
        ) : (
          t('reviewSubmission.buttons.approve')
        )}
      </Button>
      <Button
        fullWidth
        size="large"
        color="error"
        variant="contained"
        onClick={onReject}
        disabled={isSubmittingOrRejecting}
      >
        {isRejecting ? (
          <CircularProgress size={24} />
        ) : (
          t('reviewSubmission.buttons.reject')
        )}
      </Button>
    </Stack>
  );
};
